import { render } from "./RewardPageDetail.vue?vue&type=template&id=4806c399"
import script from "./RewardPageDetail.vue?vue&type=script&lang=js"
export * from "./RewardPageDetail.vue?vue&type=script&lang=js"

import "./RewardPageDetail.vue?vue&type=style&index=0&id=4806c399&lang=css"

import exportComponent from "E:\\workBase\\Vue\\hans-amdin-mobiles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__